export default {
  DOMAIN: 'kyousou-gakudan.com',
  DEFAULT_OG_IMG_PATH: '/ogImage',
  ROUTER: {
    INDEX: 'index',
    DISCOGRAPHY: 'discography',
    BIOGRAPHY: 'biography',
    ALBUM: 'album',
    ALBUM10: 'album10',
    ALBUM11: 'album11',
    ALBUM12: 'album12',
    ALBUM13: 'album13',
    ALBUM14: 'album14',
    ALBUM15: 'album15',
    DEMO: 'demo',
    ABOUTSITE: 'aboutsite',
    DISTRIBUTION: 'distribution',
    DISTRIBUTION10: 'distribution10',
    DISTRIBUTION11: 'distribution11',
    DISTRIBUTION12: 'distribution12',
    DISTRIBUTION13: 'distribution13',
    DISTRIBUTION14: 'distribution14',
    DISTRIBUTION15: 'distribution15',
    NOTFOUND: 'notfound',
  },
  LOCALE: {
    SESSION_STORAGE_KEY: 'kyousouGakudanLanguage',
    EN: 'en',
    JA: 'ja',
  },
  WINDOW: {
    MIN_HEIGHT: {
      viewSm: 100,
      viewMd: 100,
      viewLg: 800,
    },
  },
  SNS: {
    // TWITTER: 'https://twitter.com/kyousou_gakudan',
    // TWITTER_ID: 'kyousou_gakudan',
    TWITTER: 'https://x.com/LunticToneOrch',
    TWITTER_ID: 'LunticToneOrch',
    INSTAGRAM: 'https://www.instagram.com/kyousou_gakudan/',
    SOUND_CLOUD: 'https://soundcloud.com/kyousou-gakudan',
    YOUTUBE: 'https://youtube.com/@kyousougakudan',
    NICONICO: 'https://www.nicovideo.jp/user/5961480',
    BOOTH: 'https://kyousou-gakudan.booth.pm/',
    BANDCAMP: 'https://kyousou-gakudan.bandcamp.com/follow_me',
    THREADS: 'https://www.threads.net/@kyousou_gakudan',
    BLUESKY: 'https://bsky.app/profile/kyousou-gakudan.bsky.social',
    BLUESKY_ID: 'kyousou-gakudan.bsky.social',
    FACEBOOK: 'https://www.facebook.com/LunaticToneOrchestra/',
    TIKTOK: 'https://www.tiktok.com/@kyousou_gakudan',
  },
  API: {
    BASE_URL: 'https://kyousou-gakudan.com/api/',
    COUNT: 'count.php',
  },
  INSTAGRAM_POSTS: {
    // ピアノロール
    PIANO_ROLL: ['CHDRWj3nTaq', 'CHDR84rnoP6', 'CHDSdcjn-XN',],
    // drum 動画
    DRUM_MOVIE: ['CHDT1SqH2b5', 'CHDUHcsn1L2',],
    //booth
    BOOTH: ['CHGDzIcHcAu', 'CHHMQNEHph1', 'CHK0Ztwn4Tv', 'CHQAlHAnprX',],
    // drum 写真
    DRUM_IMG: [
      'CHhx1tHjjhz', 'CHnMVsiLXvm', 'CHr989cD-Ld', 'CH6uzuFDMyR', 'CIDwxFcjPhC',
      'CIYQiYtjanM', 'CIie0QWD493', 'CJONp7VjXa-', 'CKn-tFPDviw',
    ],
    // ベース写真
    BASS_IMG: ['CHIPY4CL5PP', 'CHNm5NRL8Mg', 'CHfkDKvDJFd', 'CI3GSLmjLE6',],
    // ギター写真
    GUITAR_IMG: ['CKTylYXDQyZ',],
    ALBUM14: [// 14試聴 動画
      'CHYJI-sjO0K', 'CHfh2zWDA5Y', 'CHkHMTdnJ2U', 'CHoRgv1nW7C', 'CHxe6iOjbqb',
      'CH-YCGRnvpZ', 'CILQPzijgIx', 'CIdXALhjw7I', 'CIxpXjbDaNZ', 'CJD3FYiDboi', 'CKIqCggDUAw', 'CPiYVOuDCoi',
    ],
    ALBUM14_2: [// 14試聴2
      'CPil4Ikj6F3', 'CPp4OdfjNey', 'CP2xPO3Dybu', 'CQDBsb_jsNX', 'CQN59AdDGRq', 'CQYf9MOjd85', 'CQf7OuGj6Nx',
    ],
    ALBUM14_3: [// 14試聴3
      'CQtBYrsFbkz', 'CQ2bZTVDqmY', 'CRRFWAGDgx8', 'CRd4H7Qj6im','CRyRq8bj8JM',
      'CSBtvcGFMi9', 'CSbZ4tlpiQe', 'CS6ROpkpGr8', 'CTO7rnXp9O5','CTb3H5DJqOl', 'CT_1DPOJSi-',
    ],
    ALBUM14_4: [// 14試聴4 ボーカル仮ミックス
      'CWu66lNJRQm', 'CWxfmKaJPPQ', 'CW0FIZ0JWqo', 'CW2pgv8Jwvn', 'CW5Ud33pxA9', 'CW-X4zDJqwI', 'CXBESt3JsMa',
      'CWSmiAfJHaP', 'CWYFRDKp3vs', 'CWdArc1JRlw', 'CWiCx61J94x', 'CWkobQkJFNF', 'CWnP_pTJ4_u', 'CWpx6R5JthH',
      'CVuruE-Jfnw', 'CVztTvBJVgJ', 'CV41dVfJ-4A', 'CV-Dh00J5T-', 'CWDOmvlJiB2', 'CWIXrvyJNOU', 'CWNfAjgp5-T',
    ],
    ALBUM14_5: [// 14試聴5 正試聴
      'CXN42C2N8RN', 'CXdcGSnDI_S', 'CXlZMAaLabQ', 'CXyFm21FgAa',
    ],
    ALBUM14_6: [// 14試聴6
      'CYBUQu5IGOh', 'CXqKw-SsPa4', 'CwKVJL4o_I-', 'CvegY3ks734', 'CvUJchBsOlA', 'CvEtv4zttKq', 'Cuq_wxSpu6y', 'CujUSsNRLUs', 
    ],
    ALBUM15_DEMO: [
      'Cg308nSp1ff', 'Ce8OOjdpEd9', 'CkNhIKevHMd', 'CkQEWclv-Dr', 'CkktAfxLyGN', 'CkSbGYtroa9',
      // DEMO2
      'CracfIrsUjx', 'CrSjwfur_Io', 'Cq45tuQvUo6', 'Cnq75M2It-L',
      'Cr0EhU9Lzzy', 'CuKn55nLfcq', 'CuwKQrjLMQ3',
      // DEMO3
      'DIqyDPMIfbl', 'DIvk5rBIxeP', 'DI00htDIe_A', 'DI3C_RLoXic', 
    ],
    BANDCAMP: [
      'CQn3wFvDQ7l', 'CQpHEOJjWy0', 'CQ5z8rdD2p0', 'CUbLUIbhJfy', 'ClGLaJGLwV2',
    ],
    EXPLANATION: [ // 作曲解説
      'C5vG5sRIZRN', 'C5xs6HyoUM8', 'C52zLSmo_Li', 'C55cRMZIv1Q', 'C5-lIBpIhFA',
      'C6BFGdcsxQy', 'C6DsHQUoGkn', 'C6GQ6tlJXRg', 'C6IxdMsJ5wv', 'C6LZib2Ie-K',
    ],
    ETC: [
      'CS3DM6YJP4b', //c99 サークルカット
      'CXYkcDgpYHz', // 在庫
      'CX-w9JQrKt8', // album14 cd
      'CYgMUkYoOPj', // Re:AT REST
      'CbhWezTr-VX', // album14 配信2
      'CfBYuEyMmPg', // m3 2022秋cc
      'ChP8L29v0zU', // らーめん
      'CimoPmCveWs', // ギターリペア
      'CriRhQGsr93', // 試聴アプリ
      'CuV-mAZLOXm', // threads
      'DI5py5tySZw', // m3 2025春準備
    ],
  },
  ALBUM: {
    ALBUM10: {
      IS_SALE: true,
      HAS_CROSSFADE: false,
      CROSSFADE: {
        YOUTUBE: '',
        NICONICO: '',
      },
      SHOP: [],
      DL: [
        {
          shop: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/2454287'
        },
        {
          shop: 'bandcamp',
          url: 'https://kyousou-gakudan.bandcamp.com/album/prologue'
        },
        {
          shop: 'melonbooksDl',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=966598'
        },
        {
          shop: 'dlSiteCom',
          url: 'https://www.dlsite.com/home/work/=/product_id/RJ072963.html'
        },
        {
          shop: 'mucome',
          url: 'https://mucome.net/work?id=7372'
        },
        
      ],
      DISTRIBUTION: [],
      ETC: [],
      SPECIAL: [],
    },
    ALBUM11: {
      IS_SALE: true,
      HAS_CROSSFADE: true,
      CROSSFADE: {
        YOUTUBE: '8YLjj253INw',
        NICONICO: 'sm13116169',
      },
      SHOP: [],
      DL: [
        {
          shop: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/2461426'
        },
        {
          shop: 'bandcamp',
          url: 'https://kyousou-gakudan.bandcamp.com/album/tumitugaru-syuguno-kokugouha-saidohakanaki-rintenno-toga'
        },
        {
          shop: 'melonbooksDl',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=928052'
        },
        {
          shop: 'dlSiteCom',
          url: 'https://www.dlsite.com/home/work/=/product_id/RJ073768.html'
        },
        // {
        //   shop: 'gyutto',
        //   url: 'http://gyutto.com/i/item52989'
        // },
        {
          shop: 'mucome',
          url: 'https://mucome.net/work?id=7564'
        },
      ],
      DISTRIBUTION: [],
      ETC: [],
      SPECIAL: [],
    },
    ALBUM12: {
      IS_SALE: true,
      HAS_CROSSFADE: true,
      CROSSFADE: {
        YOUTUBE: '9IpdV5JbNbY',
        NICONICO: 'sm15274213',
      },
      SHOP: [],
      DL: [
        {
          shop: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/2461561'
        },
        {
          shop: 'bandcamp',
          url: 'https://kyousou-gakudan.bandcamp.com/album/alice-corpse'
        },
        {
          shop: 'melonbooksDl',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=2128681'
        },
      ],
      DISTRIBUTION: [],
      ETC: [],
      SPECIAL: [
        { // 2022 AT REST
          title: 'message.discography.albums.a12.remixDl',
          banner: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/3569227'
        },
      ],
    },
    ALBUM13: {
      IS_SALE: true,
      HAS_CROSSFADE: false,
      CROSSFADE: {
        YOUTUBE: '',
        NICONICO: '',
      },
      SHOP: [],
      DL: [
        {
          shop: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/2461603'
        },
        {
          shop: 'bandcamp',
          url: 'https://kyousou-gakudan.bandcamp.com/album/akaguroi-otukisama-aojiroi-ohisama'
        },
        {
          shop: 'melonbooksDl',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=2128683'
        },
      ],
      DISTRIBUTION: [],
      ETC: [],
      SPECIAL: [],
    },
    ALBUM14: {
      IS_SALE: true,
      HAS_CROSSFADE: true,
      CROSSFADE: {
        YOUTUBE: 'aLeE4xplNsw',
        NICONICO: '',
      },
      SHOP: [
        {
          shop: 'melonbooks',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=1198298'
        },
      ],
      DL: [
        {
          shop: 'booth',
          url: 'https://kyousou-gakudan.booth.pm/items/3558555'
        },
        {
          shop: 'bandcamp',
          url: 'https://kyousou-gakudan.bandcamp.com/album/chronicle-of-faith'
        },
        {
          shop: 'melonbooksDl',
          url: 'https://www.melonbooks.co.jp/detail/detail.php?product_id=2128704'
        },
        {
          shop: 'iTunesStore',
          url: 'https://itunes.apple.com/jp/album/chronicle-of-faith/1612405206?uo=4&app=itunes'
        },
        {
          shop: 'amazonDigitalMusicStore',
          url: 'https://www.amazon.co.jp/dp/B09TWF1FP2/ref=dm_rwp_pur_lnd_albm_hd'
        },
        {
          shop: 'dwangoJp',
          url: 'https://pc.dwango.jp/portals/album/70459735'
        },
        {
          shop: 'recochoku',
          url: 'https://recochoku.jp/album/A2002733344/album'
        },
        {
          shop: 'dMusic',
          url: 'https://music.dmkt-sp.jp/album/A2002733344'
        },
        {
          shop: 'musicStore',
          url: 'https://musicstore.auone.jp/s/album/2002733344/ALBUM?affiliate=2510110001'
        },
        {
          shop: 'animeloMix',
          url: 'https://pc.animelo.jp/portals/album/70459735'
        }
      ],
      DISTRIBUTION: [
        {
          shop: 'spotify',
          url: 'https://open.spotify.com/album/5UNr0osYg8udTvNf8vhcDM'
        },
        {
          shop: 'appleMusic',
          url: 'https://music.apple.com/jp/album/chronicle-of-faith/1612405206?uo=4&app=music'
        },
        {
          shop: 'lineMusic',
          url: 'https://music.line.me/launch?target=album&item=mb00000000026024ca&cc=JP&v=1'
        },
        {
          shop: 'amazonMusicUnlimited',
          url: 'https://music.amazon.co.jp/albums/B09TWF1FP2'
        },
        {
          shop: 'youtubeMusic',
          url: 'https://music.youtube.com/playlist?list=OLAK5uy_kqmyCzCE1Pt74Dr5wWOAzw6IQj5C_nynk'
        },
        {
          shop: 'rakutenMusic',
          url: 'https://music.rakuten.co.jp/link/album/20721591/'
        },
        {
          shop: 'towerRecordsMusic',
          url: 'https://music.tower.jp/album/detail/1020863688'
        },
        {
          shop: 'kkBox',
          url: 'https://www.kkbox.com/jp/ja/album/UoXcRhGBxvPPP0F9-hCE009H-index.html'
        },
        {
          shop: 'awa',
          url: 'https://s.awa.fm/album/d953a1abd1991df29b21'
        },
        {
          shop: 'utaPass',
          url: 'https://au.utapass.auone.jp/'
        },
        {
          shop: 'dHits',
          url: 'https://selection.music.dmkt-sp.jp/artist/2001977218'
        },
        {
          shop: 'otoraku',
          url: 'https://otoraku.jp/',
        },
        {
          shop: 'deezer',
          url: 'https://www.deezer.com/',
        },
      ],
      ETC: [
        {
          shop: 'tikTok',
          url: 'https://www.tiktok.com/'
        },
        {
          shop: 'instagramMusicStamp',
          url: 'https://www.instagram.com/'
        },
        {
          shop: 'facebookMusicStamp',
          url: 'https://www.facebook.com/'
        },
        {
          shop: 'shazam',
          url: 'https://www.shazam.com/'
        },
      ],
      SPECIAL: [],
    },
    ALBUM15: {
      IS_SALE: false,
      HAS_CROSSFADE: false,
      CROSSFADE: {
        YOUTUBE: '',
        NICONICO: '',
      },
      SHOP: [],
      DL: [],
      DISTRIBUTION: [],
      ETC: [],
      SPECIAL: [],
    },
  },
  DISTRIBUTION: {
    SHOP: [
      {
        shop: 'melonbooks',
        url: 'https://www.melonbooks.co.jp/circle/index.php?circle_id=18180'
      },
    ],
    DISTRIBUTION: [
      {
        shop: 'spotify',
        url: 'https://open.spotify.com/intl-ja/artist/2wiEfyUPx6qD6pv1E86ObL'
      },
      {
        shop: 'appleMusic',
        url: 'https://music.apple.com/jp/artist/1612405207'
      },
      {
        shop: 'lineMusic',
        url: 'https://music.line.me/webapp/artist/mi000000001885da19'
      },
      {
        shop: 'amazonMusicUnlimited',
        url: 'https://music.amazon.co.jp/artists/B09TWBV72X'
      },
      {
        shop: 'youtubeMusic', // アルバムページ
        url: 'https://music.youtube.com/playlist?list=OLAK5uy_kqmyCzCE1Pt74Dr5wWOAzw6IQj5C_nynk'
      },
      {
        shop: 'rakutenMusic',
        url: 'https://music.rakuten.co.jp/link/artist/7867739'
      },
      {
        shop: 'towerRecordsMusic', // アルバムページ
        url: 'https://music.tower.jp/album/detail/1020863688'
      },
      {
        shop: 'kkBox',
        url: 'https://www.kkbox.com/jp/ja/artist/8rM7a9sgsPZqqj4xR_'
      },
      {
        shop: 'awa',
        url: 'https://s.awa.fm/artist/6a1cb3fd3c29aeb8d626'
      },
      {
        shop: 'utaPass',
        url: 'https://au.utapass.auone.jp/'
      },
      {
        shop: 'dHits',
        url: 'https://selection.music.dmkt-sp.jp/artist/2001977218'
      },
      {
        shop: 'otoraku',
        url: 'https://otoraku.jp/',
      },
      {
        shop: 'deezer',
        url: 'https://www.deezer.com/',
      },
    ],
    DL: [
      {
        shop: 'booth',
        url: 'https://kyousou-gakudan.booth.pm/'
      },
      {
        shop: 'bandcamp',
        url: 'https://kyousou-gakudan.bandcamp.com/'
      },
      {
        shop: 'melonbooksDl',
        url: 'https://www.melonbooks.co.jp/circle/index.php?circle_id=18180'
      },
      {
        shop: 'iTunesStore',
        url: 'https://music.apple.com/jp/artist/1612405207'
      },
      {
        shop: 'amazonDigitalMusicStore',
        url: 'https://www.amazon.co.jp/music/player/artists/B09TWBV72X/'
      },
      {
        shop: 'dwangoJp',
        url: 'https://pc.dwango.jp/portals/artist/398421'
      },
      {
        shop: 'recochoku',
        url: 'https://recochoku.jp/artist/2001977218'
      },
      {
        shop: 'dMusic',
        url: 'https://dmusic.docomo.ne.jp/artist/2001977218'
      },
      {
        shop: 'musicStore',
        url: 'https://musicstore.auone.jp/s/artist/2001977218?affiliate=2504190001'
      },
      {
        shop: 'animeloMix',
        url: 'https://pc.animelo.jp/portals/artist/398421'
      }
    ],
  },
};
